import React, { useEffect, useState } from "react";
import "../admin.css"
import Logo from "../../../assets/images/logo.jpg"
import axios from "axios";

const AdminHeader = () => {
    const [data, setData] = useState({})
    const userId = localStorage.getItem("userId")
    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        axios.get(`/api/v1/users/${userId}`)
        .then(res => {
            setData(res.data)
        })
        .catch(err => console.log(err))
    }

    return (
        <div className="admin-header-container">
            <div className="admin-header-left">
                <img src={Logo} alt="" />
            </div>
            <div className="admin-header-center">
                TRANG QUẢN LÝ
            </div>
            <div className="admin-header-right">
                Xin chào, {data.fullName}
            </div>
        </div>
    );
}

export default AdminHeader;